module.exports = __webpack_public_path__ + "static/media/icon-parking.545609f1.png";